import { FormPreviewButton } from '@risksmart-app/components/src/form-builder/FormPreviewButton';
import { useFormBuilderStore } from '@risksmart-app/components/src/form-builder/store/useFormBuilderStore';
import { useGetGuidParam } from '@risksmart-app/components/src/routes/routes.utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ObjectToolbarConfig } from 'src/blocks/object-toolbar';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs/ControlledTabs';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { PageLayout } from '../../../../../../layouts';
import DetailsTab from './tabs/details/Tab';

const QuestionnaireTemplateVersionCreatePage: FC = () => {
  const questionnaireTemplateId = useGetGuidParam('questionnaireTemplateId');
  const { t } = useTranslation(['common']);
  const { t: st } = useTranslation(['common'], {
    keyPrefix: 'questionnaire_template_versions',
  });
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const setIsPreviewingForm = useFormBuilderStore((s) => s.setIsPreviewingForm);
  const title = st('create_version_page_title');
  // Object-level toolbar (CUS-171) — flag-gated. Maps the legacy header's
  // FormPreviewButton into the toolbar's primary slot so the preview control
  // isn't dropped when object_toolbar replaces the header. The legacy
  // FormPreviewButton is kept as the flag-off fallback. (The version form owns
  // its own save controls via the form's own buttons.)
  const toolbarConfig: ObjectToolbarConfig = useMemo(
    () => ({
      header: { title },
      actions: {
        primary: [
          {
            id: 'preview',
            label: st('previewButtonLabel'),
            iconName: 'file-06',
            onClick: () => setIsPreviewingForm(true),
          },
        ],
      },
    }),
    [title, st, setIsPreviewingForm]
  );

  return (
    <PageLayout
      title={title}
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={toolbarConfig} />
        ) : undefined
      }
      actions={<FormPreviewButton />}
    >
      <ControlledTabs
        activeTabId={'details'}
        tabs={[
          {
            id: 'details',
            label: t('details'),
            content: <DetailsTab parentId={questionnaireTemplateId} />,
          },
        ]}
        variant={'container'}
      />
    </PageLayout>
  );
};

export default QuestionnaireTemplateVersionCreatePage;
